import React from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

interface PageSizeDropdownProps {
  setPageSize: (size: number) => void;
  pageSizeOptions: number[];
  currentSize: number;
  setCurrentPage?: any;
}

const PageSizeDropdown: React.FC<PageSizeDropdownProps> = ({
  setPageSize,
  pageSizeOptions,
  currentSize,
  setCurrentPage,
}) => {
  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    setCurrentPage && setCurrentPage(1);
  };

  return (
    <div className='dropdown text-start d-flex align-items-center gap-3'>
      <p className='mb-0 tooltip-text'>Rows per page</p>
      <button
        className='btn btn-sm dropdown-toggle customperpage tooltip-text'
        type='button'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        {currentSize}
      </button>
      <ul
        className='dropdown-menu'
        style={{ minWidth: 'unset' }}
      >
        {pageSizeOptions.map((size) => (
          <li key={`page_${size}`}>
            <button
              type='button'
              className={`dropdown-item ${
                currentSize === size ? 'active' : ''
              }`}
              onClick={() => handlePageSizeChange(size)}
              data-page_size={size}
            >
              {size}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PageSizeDropdown;
